export const licencesTypes = {
  ADMIN_MODULE: 'ADMIN_MODULE',
  INVESTORHUB_MODULE: 'INVESTORHUB_MODULE',
  RISKANALYSIS_MODULE: 'RISKANALYSIS_MODULE',
  SCOPEEXPLORER_MODULE: 'SCOPEEXPLORER_MODULE',
  ANALYTICALOPERATIONS_MODULE: 'ANALYTICALOPERATIONS_MODULE',
};
